import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafLoadingSpinner } from '@esi/leaf-web/lib/wc';
import '@esi/leaf-web/lib/wc/components/loading-spinner/loading-spinner';

@Component({
  selector: 'cigna-leaf-loading-spinner',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-loading-spinner
      [label]="label"
      [size]="size"
      [determinate]="determinate"
      [inverse]="inverse"
      [progress]="progress"
    ></leaf-loading-spinner>
  `,
})
export class CignaLeafLoadingSpinnerComponent {
  @Input() label: LeafLoadingSpinner['label'];
  @Input() size: LeafLoadingSpinner['size'];
  @Input() determinate: LeafLoadingSpinner['determinate'];
  @Input() inverse: LeafLoadingSpinner['inverse'];
  @Input() progress: LeafLoadingSpinner['progress'];
}
